<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <DirPath :path="['Reportes', 'Velocidad Lectora']" />
      <HeaderView v-bind="headerData" />

      <ReportsConfig />
      <template v-if="reports.school && reports.course">
        <template v-if="showData && data">
          <div class="row text-center">
            <div class="col-md-4">
              <div class="row col-10 py-4 mx-auto">
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle text-dark">
                    Promedio del curso últimos 30 días
                  </span>
                </div>
                <div class="col-12">
                  <span
                    class="text-barlow-condensed text-primary h1-xl mx-auto"
                  >
                    {{ data.avgCourseLast30days.toFixed(2) }}
                  </span>
                </div>
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle">
                    Palabras por minuto
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row col-10 py-4 mx-auto elevation-1 radius-20">
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle text-dark">
                    Velocidad Recomendada
                  </span>
                </div>
                <div class="col-12">
                  <span class="text-barlow-condensed text-logo h1-xl mx-auto">
                    {{ data.suggestedSpeed }}
                  </span>
                </div>
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle">
                    Palabras por minuto
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 mx-auto text-center">
              <div class="row col-10 py-4 mx-auto">
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle text-dark">
                    Promedio del curso período anterior
                  </span>
                </div>
                <div class="col-12">
                  <span
                    class="text-barlow-condensed text-secondary h1-xl mx-auto"
                  >
                    {{ data.avgCoursePrevPeriod.toFixed(2) }}
                  </span>
                </div>
                <div class="col-12">
                  <span class="text-barlow-condensed subtitle">
                    Palabras por minuto
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-5" v-if="data.readers.length">
            <div class="col-md-4" :class="{ 'mx-auto': !showMatrix }">
              <div class="row">
                <table class="table elevation-1">
                  <thead class="text-logo">
                    <tr>
                      <th>Nombre</th>
                      <th>Velocidad Promedio</th>
                    </tr>
                  </thead>
                  <tbody class="text-gray pointer">
                    <tr
                      v-for="(student, i) in data.readers"
                      :key="i"
                      @click="selectedStudent = i"
                    >
                      <td :class="{ 'text-logo': i == selectedStudent }">
                        {{ student.user.firstname }}
                        {{ student.user.lastname }}
                      </td>
                      <td class="text-primary">
                        {{
                          student.monthAvg[
                            student.monthAvg.length - 1
                          ].avg.toFixed(2)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <button
                  class="button mx-auto"
                  :class="{ primary: !showMatrix, secondary: showMatrix }"
                  @click="showMatrix = !showMatrix"
                >
                  {{ matrixButtonText }}
                </button>
              </div>
            </div>
            <div v-if="showMatrix" class="col-md-8">
              <div class="row col-12">
                <span
                  class="text-barlow-condensed subtitle text-primary ml-auto"
                >
                  {{ data.readers[selectedStudent].user.firstname }}
                  {{ data.readers[selectedStudent].user.lastname }}
                </span>
              </div>
              <BarLineChartContainer
                :data="chartData.avgReadingSpeed"
                :showPercent="false"
                :key="selectedStudent"
              />
            </div>
          </div>
        </template>
        <div class="row" v-if="showSpinner">
          <div class="col text-center text-gray">
            Cargando...
          </div>
        </div>
      </template>

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import BarLineChartContainer from "@/components/BarContainer/BarLineChartContainer";
import HeaderView from "@/components/HeaderView";
import ReportsConfig from "@/components/ReportsConfig";

export default {
  name: "ReadingSpeed",
  components: {
    DirPath,
    FooterComponent,
    BarLineChartContainer,
    HeaderView,
    ReportsConfig,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      showData: false,
      showSpinner: false,
      data: null,
      error: "",
      headerData: {
        title: "Velocidad Lectora",
        subTitle: "",
        body:
          "Mira qué tal está la velocidad lectora de tus estudiantes y contrasta sus resultados con las sugerencias según estándares internacionales",
        img: require("@/assets/images/Componente 35 – 1.svg"),
      },
      secCol,
      showMatrix: false,
      selectedStudent: 0,
      chartData: {
        avgReadingSpeed: {
          label: "Velocidad Promedio",
          barColor: secCol,
          data: {},
        },
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "reports", "months"]),
    matrixButtonText() {
      let text = "Ver evolución";
      if (this.showMatrix) text = "Dejar de Ver";
      return text;
    },
  },
  watch: {
    "reports.course"() {
      if (this.reports.course) this.getReportData();
    },
    selectedStudent() {
      this.formatData();
    },
  },
  methods: {
    async getReportData() {
      this.showData = false;
      this.showSpinner = true;
      this.data = null;
      this.error = "";

      let apiUrl = `${this.dataUrl}/courseBook/getReadingSpeedByCourseId?courseId=${this.reports.course}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.showData = true;

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.data = data.content;
          this.formatData();
        } else {
          this.$notify({
            title: ["Ocurrió un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.showSpinner = false;
      }
    },
    formatData() {
      let data = {};

      for (let charData of this.data.readers[this.selectedStudent].monthAvg) {
        let { month, avg } = charData;
        data[this.months[month]] = Number.parseInt(avg);
      }

      this.chartData.avgReadingSpeed.data = data;
    },
  },
  mounted() {
    if (this.reports.course) this.getReportData();
  },
};
</script>
